export default "__VITE_ASSET__BVHAne7E__"